<div class="d-flex flex-column ws-flex-auto min-height-0">
    <ws-bread-crumbs [breadcrumbs]="breadcrumbs" currentPageTitle="Return Settings"></ws-bread-crumbs>
    <div class="ws-section">
        <div class="ws-section__header">
            <h4 class="ws-section__header__title page-title">Return Settings</h4>
            <div class="ws-section__header__actions">
                @if (!isEditMode && !editLock && hasEditPermission) {
                    <div class="ws-section__header__actions__item">
                        <button
                            class="ace-btn btn-sm btn-primary has-icon"
                            data-qa="return-settings-edit"
                            (click)="setEditMode()"
                        >
                            <i class="fa fa-pencil"></i>
                        </button>
                    </div>
                }
                @if (isEditMode) {
                    <div class="ws-section__header__actions__item">
                        <button
                            class="ace-btn btn-sm btn-primary has-icon"
                            data-qa="return-settings-save"
                            (click)="save()"
                            [disabled]="isLoading || !hasChanges"
                        >
                            <i class="fa fa-save"></i>
                        </button>
                        <button
                            class="ace-btn btn-sm btn-primary btn-danger has-icon"
                            data-qa="return-settings-cancel"
                            (click)="cancelEdit()"
                        >
                            <i class="fa fa-close"></i>
                        </button>
                    </div>
                }
            </div>
        </div>
    </div>
    <div class="ws-section flex-grow-1 bg-white py-3 px-2 ace-radius position-relative min-height-0">
        @if (isLoading) {
            <ws-ace-loader [hideLabel]="false"></ws-ace-loader>
        }
        @if (busyIndicatorMessageManager.count() > 0) {
            <ws-busy-indicator [message]="busyIndicatorMessageManager.message"></ws-busy-indicator>
        }
        <return-settings
            [entityId]="companyId"
            [entityType]="ReturnSettingsEntityTypeEnum.Company"
            (onInitialized)="onReturnSettingsInitialized()"
            (changed)="onReturnSettingsChanged($event)"
        >
        </return-settings>
    </div>
</div>
